/* Copyright (c) 2019-2020 CLOUDPILOTS Software & Consulting GmbH */

// *** Do not modify this file, entry point core/app.js *** //

import React from 'react';
import ReactDOM from 'react-dom';
import App from './core/app';
import './core/index.css';
import * as serviceWorker from './core/serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
